import { render, staticRenderFns } from "./ContestAllyListComponent.vue?vue&type=template&id=1a711ad6"
import script from "./ContestAllyListComponent.vue?vue&type=script&lang=js"
export * from "./ContestAllyListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports